export const formatPropertyPrice = (
  priceRange?: {
    min?: number | null;
    max?: number | null;
  } | null
) => {
  if (!priceRange) {
    return {
      min: '',
      max: '',
      formattedPrice: '',
    };
  }

  const min = priceRange.min
    ? `$${priceRange.min?.toLocaleString('en') || ''}`
    : '';
  const max = priceRange.max
    ? `$${priceRange.max?.toLocaleString('en') || ''}`
    : '';

  return {
    min,
    max,
    formattedPrice: priceRange.min && priceRange.max ? `${min} - ${max}` : min,
  };
};
